module.exports = __webpack_public_path__ + "static/media/icon8.fb0a95d6.png";